var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    fill: "currentColor",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h33v33H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.344 4.64V2.579H9.28v2.063H6.187a3.093 3.093 0 0 0-3.093 3.093v19.594a3.093 3.093 0 0 0 3.094 3.094h20.625a3.093 3.093 0 0 0 3.093-3.094V7.734a3.093 3.093 0 0 0-3.093-3.093h-3.094V2.578h-2.063v2.063zM9.28 6.704v1.031h2.063v-1.03h10.312v1.03h2.063v-1.03h3.093c.57 0 1.032.46 1.032 1.03v2.063H5.156V7.734c0-.57.462-1.03 1.032-1.03zM5.156 11.86v15.47c0 .57.462 1.03 1.032 1.03h20.625a1.03 1.03 0 0 0 1.03-1.03v-15.47zm19.594 4.125v-2.062h-2.062v2.062zm-14.437-2.062v2.062H8.25v-2.062zm5.156 0h2.062v2.062H15.47zm9.281 5.156v2.063h-2.062v-2.063zm-16.5 0h2.063v2.063H8.25zm9.281 0H15.47v2.063h2.062zm-7.218 5.156v2.063H8.25v-2.063zm7.218 0H15.47v2.063h2.062z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendarIcon;